<a
	class="{{ initOptions.style }}"
  target="_blank"
  name="{{ initOptions.id }}"
	href="{{ initOptions.url }}"
  >{{ initOptions.inner_text }}
</a>
